let singleton = null;
let singletonEnforcer = 'singletonEnforcer';

/**
 * Win Resize 이벤트를 브라우저 크기변경이 완료될때까지 기다린후 전달하는 유틸성 클래스
 * @category common
 * @example
 * import WinResize from '../common/WinResize';
 * 
 * let winRe = WinResize.instance;
 * winRe.init();
 * this.winRe.addCallback( () => console.log( 'win resize' ) );
*/
class WinResize{

    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw "Cannot--construct singleton";
        }
        this.timer = null;
        this.callbackFnList = [];
    }

    static get instance() {
        singleton = (singleton)? singleton: new WinResize(singletonEnforcer);
        return singleton;
    }

    init(){
        $(window).on( 'resize', (ev)=>{
            if(this.timer){
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => this.callbackFnList.forEach( _fn => _fn() ), 300);
        });
    }

    addCallback(_fn){
        this.callbackFnList.push(_fn);
    }

}


export default WinResize;